import type { PatientAdminApiRouter } from '@liza/patient-admin-api';
import { createTRPCContext } from '@trpc/tanstack-react-query';

type TRPCContext = ReturnType<typeof createTRPCContext<PatientAdminApiRouter>>;

const trpcContext = createTRPCContext<PatientAdminApiRouter>();

export const TRPCProvider: TRPCContext['TRPCProvider'] = trpcContext.TRPCProvider;
export const useTRPC: TRPCContext['useTRPC'] = trpcContext.useTRPC;
export const useTRPCClient: TRPCContext['useTRPCClient'] = trpcContext.useTRPCClient;
